import BasicResources from './basic-resources';

// The Resources class provides a set of static fields, one for each resource
// needed by the application. Users should generally call its initialise() method, to set
// up the environment and create all of the resources the application will use.

// In some (hopefully, rare) situations, it may be required that the environment is provided
// from a parent application. In these situations, call createResources(parentEnv) directly,
// and pass it the Resources.env object that is the environment required.
class Resources {
    // createResources() should create a static field for each resource:
    //
    //    const env = parentEnv || Resources.env;
    //
    //    Resources.colours = env.resource('Colours')
    //                           .baseUrl('@AvatarAdminBaseUrl')
    //                           .service('colours');
    //
    //
    // Application code can then access those resources like so:
    //
    //    const allColours = Resource.colours.get().send();

    static createResources(parentEnv) {
        if (parentEnv) {
            Resources.env = parentEnv;
        }

        // TODO: 5. ADD STATIC PROPERTIES FOR EACH OF YOUR RESOURCES
        //
        // You should replace this placeholder resource with the ones you
        // actually need in your application.
        const env = Resources.env;

        // List down all the base urls applicable for the application
        const SIGN_IN_CARDS_BASE_URL = '@SignInCardGatewayEndpoint';
        // new gateway endpoint
        const STUDENT_MANAGER_BASE_URL = '@StudentManagerGatewayEndpoint';

        // Classes
        Resources.getTeacherClasses = env.resource('getTeacherClasses')
            .baseUrl(STUDENT_MANAGER_BASE_URL)
            .service('classrooms/products/{productId}');

        Resources.editClassName = env.resource('editClassName')
            .baseUrl(STUDENT_MANAGER_BASE_URL)
            .service('classrooms/{classroomId}');


        // Groups
        Resources.addNewGroup = env.resource('addNewGroup')
            .baseUrl(STUDENT_MANAGER_BASE_URL)
            .service('classrooms/{classroomId}/groups');

        Resources.editGroupCourses = env.resource('editGroupCourses')
            .baseUrl(STUDENT_MANAGER_BASE_URL)
            .service('{classroomId}/groups/{groupId}');

        Resources.deleteGroup = env.resource('deleteGroup')
            .baseUrl(STUDENT_MANAGER_BASE_URL)
            .service('{classroomId}/groups/{groupId}');

        Resources.classroomGroups = env.resource('classroomGroups')
            .baseUrl(STUDENT_MANAGER_BASE_URL)
            .service('classrooms/{classId}/products/{productId}/groups/{groupId}');

        // Courses
        Resources.getDefaultCourse = env.resource('getDefaultCourse')
            .baseUrl(STUDENT_MANAGER_BASE_URL)
            .service('/classrooms/{classId}/products/{productId}/groups/default-data');

        Resources.getCourseYears = env.resource('getCourseYears')
            .baseUrl(STUDENT_MANAGER_BASE_URL)
            .service('yearGroups');

        Resources.getCourses = env.resource('getCourses')
            .baseUrl(STUDENT_MANAGER_BASE_URL)
            .service('courses');

        Resources.getSchoolCourses = env.resource('getSchoolCourses')
            .baseUrl(STUDENT_MANAGER_BASE_URL)
            .service('courses/schoolCourses');

        // Sign In Cards
        Resources.downloadStudentSignInCards = env.resource('downloadStudentSignInCards')
            .baseUrl(SIGN_IN_CARDS_BASE_URL)
            .service('api/v1/products/{productId}/studentSignInCards');

        Resources.getDownloadStudentSignInCards = env.resource('getDownloadStudentSignInCards')
            .baseUrl(SIGN_IN_CARDS_BASE_URL)
            .service('api/v1/products/{productId}/studentSignInCards/{downloadKey}');

        // CTA Tools actions
        Resources.exportStudents = env.resource('exportStudents')
            .baseUrl(STUDENT_MANAGER_BASE_URL)
            .service('students/classrooms/{currentClassId}/products/{productId}/csv?AuthToken={authToken}');

        // Students
        Resources.changePassword = env.resource('changePassword')
            .baseUrl(STUDENT_MANAGER_BASE_URL)
            .service('students/changePassword');

        Resources.getConfigurationItem = async key => env.getConfigurationItem(key);

        Resources.getStudentMoveCopyData = env.resource('getStudentMoveCopyData')
            .baseUrl(STUDENT_MANAGER_BASE_URL)
            .service('classrooms/school-classrooms/products/{productId}');

        Resources.getStudentManagementData = env.resource('getStudentManagementData')
            .baseUrl(STUDENT_MANAGER_BASE_URL)
            .service('schools/products/{productId}/schoolInfo');

        Resources.getAddStudentClasses = env.resource('getAddStudentClasses')
            .baseUrl(STUDENT_MANAGER_BASE_URL)
            .service('classrooms/{classId}/products/{productId}');

        Resources.assignClassStudent = env.resource('assignClassStudent')
            .baseUrl(STUDENT_MANAGER_BASE_URL)
            .service('students/assign');

        Resources.assignGroup = env.resource('assignGroup')
            .baseUrl(STUDENT_MANAGER_BASE_URL)
            .service('students/classrooms/{classId}/groups/{groupId}');

        Resources.createMultiYearGroups = env.resource('createMultiYearGroups')
            .baseUrl(STUDENT_MANAGER_BASE_URL)
            .service('classrooms/{classId}/multi-year-groups');
    }


    // Initialise the environment and resources, based on the provided
    // environment name.  We return the environment so the caller has
    // access to everything, in particular the authToken if one was
    // passed in the query parameters.

    static initialise(envName, credentials) {
        Resources.env = BasicResources.initialise(envName, credentials);

        Resources.createResources();

        return Resources.env;
    }
}

export default Resources;



// WEBPACK FOOTER //
// ./helpers/resources.js